module.exports = function() {
  return new Worker(__webpack_public_path__ + "9cdc8dbdf417566d1cba.worker.js");
};